import './Tag.css'
import cx from 'classnames'
import { Tooltip } from '../Tooltip/Tooltip'

const variantClasses = {
  default: 'tag-default',
  subtle: 'tag-subtle'
}

export function Tag({
  label,
  title,
  className,
  variant = 'default'
}: {
  label: React.ReactNode
  title?: string
  className?: string
  variant?: 'default' | 'subtle'
}) {
  const tag = (
    <div className={cx('tag-base', variantClasses[variant], className)}>
      <span className="tag-label">{label}</span>
    </div>
  )

  if (!title) {
    return tag
  }

  return (
    <Tooltip variant="info" content={title}>
      {tag}
    </Tooltip>
  )
}
